import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./UserDashboard.css";
import Cookies from "js-cookie";
import axios from 'axios';
import { Redirect } from "react-router-dom";
import { Empty, message, Avatar, Spin, Tooltip } from "antd";
import { RightOutlined, LeftOutlined, CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import {
    getAllAlerts,getTotalGroupPercentage
} from "../../redux/DashboardRedux/DashboardActions";

const UserDashboard = () => {
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");
    const dispatch = useDispatch();
    const [leftArrow, showLeftArrow] = useState(null);
    const setRightArrowDiv = (index) => {
        showLeftArrow(index)
    }
    const setLeftArrowDiv = (index) => {
        showLeftArrow(null)
    }

    const [leftArrow1, showLeftArrow1] = useState(null);
    const setRightArrowDiv1 = (index) => {
        showLeftArrow1(index)
    }
    const setLeftArrowDiv1 = (index) => {
        showLeftArrow1(null)
    }

    const firstLetters = userLogin
        .split('@')[0]
        .split('.')
        .map(part => part[0])
        .join('').toUpperCase();

    const [currentDate, setCurrentDate] = useState(new Date());
    const getWeekDays = () => {
        const weekdays = [];
        const startDate = new Date(currentDate);
        startDate.setDate(startDate.getDate() - startDate.getDay() + 1); // Start from Monday
        for (let i = 0; i < 7; i++) {
            const day = new Date(startDate);
            day.setDate(startDate.getDate() + i);
            weekdays.push(day);
        }
        return weekdays;
    };

    const handlePreviousDay = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() - 7);
        setCurrentDate(newDate);
    };

    const handleNextDay = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() + 7);
        setCurrentDate(newDate);
    };

    var options = { weekday: 'short' };
    const selecDate = new Date().toLocaleDateString('en-US', options);
    const [selectedDate, setSelectedDate] = useState(selecDate);
    const weekdays = getWeekDays();
    const [usertasks, getUsertasks] = useState([]);
    const [completedTasks, getCompletedTasks] = useState([]);
    const [openTaskLoading, setopenTaskLoading] = useState(false);
    const [taskloader, setTaskLoader] = useState({})
    const [showCompletedTasks, setShowCompletedTasks] = useState(false);

    const toggleCompletedTasks = () => {
        setShowCompletedTasks(!showCompletedTasks);
    };

    const handleDateClick = (day) => {
        setopenTaskLoading(true)
        taskDetails(day)
        dispatch(getAllAlerts());
    }

    var temp = 0;
    useEffect(() => {
        if (temp === 0) {
            temp = 1;
            setopenTaskLoading(true)
            taskDetails(selectedDate);
            dispatch(getAllAlerts());
            CompletedTasks()
        }
    }, []);
    const alertsData = useSelector(
        (state) => state.dashboardreducer.totalAlerts
    )

    const taskDetails = async (day) => {
        let selDate = day
        setSelectedDate(selDate)
        try {
            await axios({
                url:
                    `${process.env.REACT_APP_BASE_URL}UserTask/CalculateOverDue?uname=` +
                    userLogin + `&day=` + selDate,
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            })
                .then((resp) => {
                    getUsertasks(resp.data)
                    setopenTaskLoading(false)
                    setTaskLoader(false)
                })
        }
        catch (error) {
            message.error("Unbale to load your tasks")
            setopenTaskLoading(false)
            setTaskLoader(false)
        }
    };

    const CompletedTasks = async () => {
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/GetCompletedUsertask?uname=` + userLogin;
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            const res = await axios.get(url, config)
            if (res.data.statusCode === 200) {
                const resdata = res.data.payload
                const data = JSON.parse(resdata)
                getCompletedTasks(data)
            }
            else if (res.data.statusCode === 500) {
                message.warning(response.data.message)
            }
        }
        catch (error) {
            // message.error('Error, Try again..');
        }

    };

    const handleStatusUpdate = async (value, index) => {
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/updatestatus?taskid=` + value + `&status=Completed&uname=` + userLogin;
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        const data = [];
        setTaskLoader(prevState => ({ ...prevState, [index]: true }))
        try {
            const res = await axios.post(url, data, config)
            const resp = await taskDetails(selectedDate);
            dispatch(getAllAlerts());
            const comData = await CompletedTasks();
            message.success(`Updated your task status successfully.`);
            dispatch(getTotalGroupPercentage());
        }
        catch (error) {
            message.error('Task status is not Updated, Try again..');
            setTaskLoader(prevState => ({ ...prevState, [index]: false }))
        }
    };

    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }
    return (
        <>
            <div className="wholediv-for-usertasks">
                <div className="usertasks">
                    <div className="calendar-view">
                        <div className="calendar-div">
                            <input onClick={handlePreviousDay} value="<" type="button"
                                className="move" />
                            <div className="inside-calender">
                                {
                                    weekdays.map((day, index) => (
                                        <Tooltip placement="top" title={day.getDate() + ", " + (day.toLocaleString('en-US', { month: 'long' }))} color={'#002766'}>
                                            <div
                                                key={index}
                                                className={`${day.toDateString() === new Date().toDateString() ? 'highlight' : 'day-name'} 
                                                        ${day.toLocaleDateString('en-US', { weekday: 'short' }) === selectedDate ? 'selected-date' : ''}`}
                                                onClick={() => handleDateClick(day.toLocaleDateString('en-US', { weekday: 'short' }))}>
                                                <p style={{ textAlign: "center", marginLeft: "10%" }}>{day.toLocaleDateString('en-US', { weekday: 'short' })}</p>
                                                <p style={{ textAlign: "center", marginTop: "13px" }}>{day.getDate()}</p>
                                            </div>
                                        </Tooltip>
                                    ))
                                }
                            </div>

                            <input onClick={handleNextDay} value=">" type="button"
                                className="move" />
                        </div>
                    </div>

                    <div className="usertasks-display">
                        {openTaskLoading ? <div className="render-tasks">
                            <div className="example">
                                <Spin size="large" />
                            </div>
                        </div> :
                            <div className="render-tasks">
                                <div>
                                    {
                                        usertasks.length !== 0 ?
                                            <div >{
                                                usertasks.map((item, index) => {
                                                    return (
                                                        <div className="tasklist-class">
                                                            <div className="inside-tasks" >
                                                                <div className="avatar-div">
                                                                    <Avatar
                                                                        style={{
                                                                            backgroundColor: '#002766',
                                                                        }}
                                                                    >
                                                                        {firstLetters}
                                                                    </Avatar>
                                                                </div>
                                                                <div className="name-arrow-class">
                                                                    <div className="taskname-class">
                                                                        <div className="task-name">
                                                                            {item.taskName}
                                                                        </div>
                                                                        <div className="today-date">
                                                                            <>{item.task_Status}</>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        leftArrow === index ?
                                                                            <div className="arrow-icon-div">
                                                                                <Tooltip color={'#002766'} title="Click here to mark as completed">
                                                                                    {taskloader[index] ? <LoadingOutlined className="status-icon" /> :
                                                                                        <CheckCircleOutlined className="status-icon" onClick={() => handleStatusUpdate(item.taskId, index)} />}
                                                                                </Tooltip>
                                                                                <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv(index)} />
                                                                            </div>
                                                                            : <div className="arrow-icon">
                                                                                <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv(index)} />
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            : <div>
                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                    className="notask-heading"
                                                    description={
                                                        <span>
                                                            No tasks for the day
                                                        </span>
                                                    }
                                                >
                                                </Empty>
                                                {/* <h1 className="notask-heading">No tasks for the day</h1> */}
                                            </div>
                                    }
                                </div>
                                <div className="overdue-tasks">
                                    {
                                        alertsData.length !== 0 ?
                                            <div >{
                                                alertsData.map((item, index) => {
                                                    return (
                                                        <div className="tasklist-class">
                                                            <div className="inside-tasks">
                                                                <div className="avatar-div">
                                                                    <Avatar
                                                                        style={{
                                                                            backgroundColor: '#002766',
                                                                            cursor: "pointer"
                                                                        }}
                                                                    >
                                                                        {firstLetters}
                                                                    </Avatar>
                                                                </div>
                                                                <div className="name-arrow-class">
                                                                    <div className="taskname-class">
                                                                        <div className="task-name">
                                                                            {item.taskName}
                                                                        </div>
                                                                        <div className="today-date" style={{ color: "rgba(255, 163, 158, 1)" }}>
                                                                            Overdue since {item.task_Due_Date}
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        leftArrow1 === index ?
                                                                            <div className="arrow-icon-div">
                                                                                <Tooltip color={'#002766'} title="Click here to mark as completed">
                                                                                    {taskloader[index] ? <LoadingOutlined className="status-icon" /> :
                                                                                        <CheckCircleOutlined className="status-icon" onClick={() => handleStatusUpdate(item.taskId, index)} />}
                                                                                </Tooltip>
                                                                                <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv1(index)} />
                                                                            </div>
                                                                            : <div className="arrow-icon">
                                                                                <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv1(index)} />
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            : <div>
                                                {/* <h1 className="notask-heading" style={{ marginLeft: "45%" }}>No tasks</h1> */}
                                            </div>
                                    }
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", marginBottom: "12px" }}>
                                    <a onClick={toggleCompletedTasks} style={{ textDecoration: "underline", color: "#002766", fontWeight: "600" }}>
                                        {showCompletedTasks ? 'Hide Completed Tasks' : 'Show Completed Tasks'}
                                    </a>
                                </div>
                                <div>
                                    {showCompletedTasks && (
                                        <div className="overdue-tasks">
                                            {completedTasks.length !== 0 ? (
                                                <div >{
                                                    completedTasks.map((item, index) => {
                                                        return (
                                                            <div className="tasklist-class">
                                                                <div className="inside-tasks">
                                                                    <div className="avatar-div">
                                                                        <Avatar
                                                                            style={{
                                                                                backgroundColor: '#002766',
                                                                            }}
                                                                        >
                                                                            {firstLetters}
                                                                        </Avatar>
                                                                    </div>
                                                                    <div className="name-arrow-class">
                                                                        <div className="taskname-class">
                                                                            <div className="task-name" key={index}>
                                                                                {item.TaskName}
                                                                            </div>
                                                                            <div className="today-date" style={{ color: "rgba(143, 184, 72, 1)" }}>
                                                                                Completed
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            ) : (
                                                <div>
                                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                        className="notask-heading"
                                                    >
                                                    </Empty>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>}
                    </div>
                </div >
            </div >
        </>

    );
}
export default UserDashboard;